import React, { useMemo } from 'react';
import { FileText, PaperPlaneTilt, CurrencyDollar } from '@phosphor-icons/react';
import { StatsCardGrid } from '../shared/StatsCardGrid';

export const DODDStatsCards = ({ claims, filterStatus, onFilterChange }) => {
  const draftCount = claims.filter((c) => c.status === 'Draft').length;
  const pendingCount = claims.filter((c) => c.status === 'Pending').length;
  const totalRevenue = claims.reduce(
    (sum, c) => sum + c.estimated_reimbursement,
    0
  );

  const cards = useMemo(
    () => [
      { label: 'Total Claims', value: claims.length, icon: FileText, color: 'indigo', filter: '', testid: 'dodd-stat-total' },
      { label: 'Draft', value: draftCount, icon: FileText, color: 'amber', filter: 'Draft', testid: 'dodd-stat-draft' },
      { label: 'Pending', value: pendingCount, icon: PaperPlaneTilt, color: 'blue', filter: 'Pending', testid: 'dodd-stat-pending' },
      { label: 'Total Revenue', value: totalRevenue, icon: CurrencyDollar, color: 'emerald', isCurrency: true, testid: 'dodd-stat-revenue' },
    ],
    [claims.length, draftCount, pendingCount, totalRevenue]
  );

  return (
    <StatsCardGrid
      columns={4}
      activeFilter={filterStatus}
      onFilterChange={onFilterChange}
      cards={cards}
    />
  );
};
